export default new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format;
